import { render, staticRenderFns } from "./FlutterwaveTransactionDetail.vue?vue&type=template&id=2ef79ef3&scoped=true"
import script from "./FlutterwaveTransactionDetail.vue?vue&type=script&lang=js"
export * from "./FlutterwaveTransactionDetail.vue?vue&type=script&lang=js"
import style0 from "./FlutterwaveTransactionDetail.vue?vue&type=style&index=0&id=2ef79ef3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ef79ef3",
  null
  
)

export default component.exports